
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from 'react-router-dom';
import toast from "react-hot-toast";

import { MdDoNotDisturb } from "react-icons/md";
import CustomModal from "../../common/CustomModal";

import { AddPlusOne, RevokePlusOneUser, ResendInvitation, } from "../../redux/v2/user/actions";

import { isValidEmail, isValidNumber } from "../../utils";

import "./style.css"

function PlusOne(props) {
   const navigate = useNavigate();
   const { account } = props.User;

   const [method, setMethod] = useState("email");
   const [status, setStatus] = useState(1);
   const [hasInvite, setHasInvite] = useState(false);
   const [isFormComplete, setIsFormComplete] = useState(false);
   const [resendModal, setResendModal] = useState(false);

   const [details, setDetails] = useState({
      firstName: "",
      lastName: "",
      email: "",
      number: "",
      message: "",
   })
   let defaultMessage = `${details.firstName}, this is a new Program offered at work, I'm sending you a link to join.`;

   useEffect(() => {

      if (account?.user?.child_user && account?.user?.child_user_info?.status) {
         setHasInvite(true);
      } else {
         setHasInvite(false);
      }
   }, [account?.user]);

   useEffect(() => {
      if (account?.user?.child_user_info && account?.user?.child_user_info.status) {
         let isUsingNumber = account?.user?.child_user_info?.mobile_number;
         setMethod("email");
         setDetails({
            ...details,
            number: account?.user?.child_user_info?.mobile_number,
            email: account?.user?.child_user_info?.email_address,
         })
      }
   }, [account?.user?.child_user_info]);


   const onChangeDetails = (e, field) => {
      setIsFormComplete(false);

      let tempDetails = {
         ...details,
         [field]: e.target.value
      }

      setDetails({
         ...tempDetails
      });


      if (
         (tempDetails.firstName && tempDetails.firstName.length > 2) &&
         (tempDetails.lastName && tempDetails.lastName.length > 2) &&
         (
            (
               method == "email" &&
               isValidEmail(tempDetails.email)
            ) ||
            (
               method == "text" &&
               isValidNumber(tempDetails.number)
            )
         )
      ) {
         setIsFormComplete(true);
      }
   };

   const sendInvite = async () => {
      const toastId = toast.loading("Sending Invititaion...");

      let payload = {
         ...details,
         message: details.message || defaultMessage
      }

      const res = await props.AddPlusOne(payload);
      if (res.success) {

         setDetails({
            firstName: "",
            lastName: "",
            email: "",
            number: "",
            message: "",
         });

         toast.success('Invitation Sent!', {
            id: toastId,
         });

         setStatus(3);

      } else {

         if (res.message != "Your email is already linked to INDI.") {
            toast.error('Failed to send invitation! (' + res.message + ')', {
               id: toastId,
            });
         } else {
            toast.dismiss(toastId);
         }

      }

      if (!res.isValidNumber && method == "text") {
         toast.error("Unable to send invitation, invalid number");
      }

   };

   // Dynamic text
   let isUsingNumber = account?.user?.child_user_info?.mobile_number
   let invited = isUsingNumber ? (account?.user?.child_user_info.first_name + " " + account?.user?.child_user_info.last_name) : account?.user?.child_user_info?.email_address;
   let company = account?.user?.name;
   let companyID = account?.user?.company;


   return (
      <div style={{ paddingTop: '1px' }}>
         <CustomModal
            id="delete-ad"
            show={resendModal}
            toggle={() => setResendModal(!resendModal)}
            title="Resend Invitation"
            body={
               <>
                  <div id="invite-details">
                     <div id="invite-method">
                        <button className={method === "email" ? "active" : ""} onClick={() => setMethod("email")}>EMAIL</button>
                     </div>

                     {method === "email" &&
                        <input type="email" placeholder="Email Address" value={details.email} onChange={(e) => {
                           onChangeDetails(e, "email");
                           if (details.number) {
                              onChangeDetails({ target: { value: "" } }, "number")
                           }
                        }} />
                     }

                     {method === "text" &&
                        <input type="number" placeholder="(555) 555-5555" value={details.number} onChange={(e) => {
                           if (e.target.value.length < 11) {
                              onChangeDetails(e, "number");
                           }
                        }} />
                     }
                  </div>
               </>
            }
            footerButtons={
               [
                  {
                     label: "RESEND",
                     action: async () => {
                        const toastId = toast.loading("Sending Invititaion...");

                        const res = await props.ResendInvitation(method, details.number, details.email, companyID);

                        if (res.success) {
                           toast.success('Invitation Sent!', {
                              id: toastId,
                           });
                        } else {
                           toast.error('Failed to send invitation! (' + res.message + ')', {
                              id: toastId,
                           });
                        }
                     },
                  },
               ]
            }
         />

         <div className="flex-c">
            <div id="plusone-content" className="page-content-v2">
               {
                  status === 1 && <>
                     <p>
                        All employees at {company} have one free membership to gift to a spouse or friend.
                     </p>

                     {
                        !hasInvite
                           ? <div id="po-c-send-invite-form">
                              <p>Send Invite</p>

                              <div id="invite-method">
                                 <button className={method === "email" ? "active" : ""} onClick={() => setMethod("email")}>EMAIL</button>
                              </div>

                              <div id="invite-details">
                                 <span>Their Details</span>
                                 <input type="text" placeholder="First Name" value={details.firstName} onChange={(e) => onChangeDetails(e, "firstName")} />
                                 <input type="text" placeholder="Last Name" value={details.lastName} onChange={(e) => onChangeDetails(e, "lastName")} />

                                 {method === "email" &&
                                    <input type="email" placeholder="Email Address" value={details.email} onChange={(e) => {
                                       onChangeDetails(e, "email");
                                       if (details.number) {
                                          onChangeDetails({ target: { value: "" } }, "number")
                                       }
                                    }} />
                                 }

                                 {method === "text" &&
                                    <input type="number" placeholder="(555) 555-5555" value={details.number} onChange={(e) => {
                                       if (e.target.value.length < 11) {
                                          onChangeDetails(e, "number");
                                          if (details.email) {
                                             onChangeDetails({ target: { value: "" } }, "email")
                                          }
                                       }
                                    }} />
                                 }

                              </div>

                              <button disabled={!isFormComplete} className="invite-button" onClick={() => setStatus(2)}>NEXT</button>

                           </div>
                           : <div id="po-c-send-invite-form" className="has-invite">
                              <p>NO INVITES REMAINING</p>
                              <span>Currently, your +1 is held by:</span>
                              <strong>{invited}</strong>

                              <div style={{ widt: "100%", padding: "0 15px" }}>
                                 <button className="resend-invitation"
                                    onClick={() => {
                                       setResendModal(true);
                                    }}
                                 >RESEND INVITATION</button>

                                 <button className="invite-button" onClick={() => navigate("/")}>BACK HOME</button>
                                 <button className="invite-button revoke" onClick={() => setStatus(0)}>
                                    <MdDoNotDisturb />
                                    REVOKE ACCESS
                                 </button>
                              </div>
                           </div>
                     }


                  </>
               }

               {
                  status === 2 && <>

                     <div id="po-c-send-invite-form" style={{ padding: "0 30px" }}>
                        <p style={{ marginBottom: 0 }}>Send Invite</p>

                        <div id="invite-details" style={{ marginTop: "10px" }}>
                           <span>Write a short message to include with the invite: </span>
                           <textarea type="text" placeholder={defaultMessage} value={details.message} onChange={(e) => onChangeDetails(e, "message")} />

                        </div>
                        <div className="invite-buttons">
                           <button className="invite-button" onClick={() => setStatus(1)}>BACK</button>
                           <button className="invite-button" onClick={() => sendInvite()}>SEND</button>
                        </div>
                     </div>
                  </>
               }

               {
                  status === 3 && <>

                     <div id="po-c-send-invite-form">
                        <p style={{ marginBottom: 0 }}>Invite Sent!</p>

                        <div id="invite-details" style={{ textAlign: "center" }}>
                           <span>You can view or change the status of your invite through the main menu </span>
                        </div>

                        <button className="invite-button" onClick={() => setStatus(1)}>BACK HOME</button>
                     </div>
                  </>
               }

               {
                  status === 0 && <>

                     <div id="po-c-send-invite-form" className="has-invite">
                        <span>Are you sure you want to revoke access to your +1:</span>
                        <strong>{invited}</strong>

                        <div style={{ widt: "100%", padding: "0 15px" }}>
                           <button className="invite-button revoke fin" onClick={async () => {
                              const toastId = toast.loading("Revoking Access...");
                              const res = await props.RevokePlusOneUser(account?.user?.child_user, account?.user?.child_user_info.email_address);

                              if (res) {
                                 toast.success('Access Revoked!', {
                                    id: toastId,
                                 });
                                 setStatus(1);
                              } else {
                                 toast.error('Failed to revoke user access.', {
                                    id: toastId,
                                 });
                              }

                           }} style={{ backgroundColor: "red", color: "#fff" }}>
                              <MdDoNotDisturb />
                              REVOKE ACCESS
                           </button>
                           <button className="invite-button" onClick={() => navigate("/")}>BACK HOME</button>
                        </div>
                     </div>
                  </>
               }
            </div>
         </div>


      </div>
   );
}

const mapStateToProps = (state) => ({
   User: state.User,
});

export default connect(mapStateToProps, {
   AddPlusOne,
   RevokePlusOneUser,
   ResendInvitation,
})(PlusOne);